// Hivatalos cégadatok – egyetlen forrás minden oldalhoz (kapcsolat, impresszum,
// adatkezelési tájékoztató, ÁSZF, footer, schema.org).
// Forrás: e-cégjegyzék / céginformáció (2026). Változás esetén csak itt kell módosítani,
// valamint a public/index.html statikus JSON-LD blokkjában.

export const SITE_URL = "https://greenislandinvest.hu";

export const COMPANY = {
  shortName: "Green Island Invest Zrt.",
  fullName: "Green Island Invest Zártkörűen Működő Részvénytársaság",
  slogan: "A jövő energiája",
  foundingYear: 2022,
  taxNumber: "32140387-2-13",
  euVatNumber: "HU32140387",
  registrationNumber: "13-10-042570",
  registryCourt: "Budapest Környéki Törvényszék Cégbírósága",
  mainActivity: "4664 Egyéb gép, berendezés nagykereskedelme",
  address: {
    postalCode: "2074",
    city: "Perbál",
    street: "Ipari Park 17.",
    lot: "hrsz. 1142/6.",
    country: "HU",
  },
  emails: [
    "info@greenislandinvest.hu",
    "iroda@greenislandinvest.hu",
    "penzugy@greenislandinvest.hu",
    "engedelyeztetes@greenislandinvest.hu",
  ],
  phones: ["+36 70 315 7070", "+36 70 315 4188", "+36 70 758 1947"],
  mainEmail: "info@greenislandinvest.hu",
  mainPhone: "+36 70 315 7070",
  logo: `${SITE_URL}/logo.png`,
  socials: [
    "https://www.facebook.com/greenislandinvestzrt",
    "https://www.instagram.com/greenislandinvest",
    "https://www.tiktok.com/@greenislandinvest",
    "https://www.linkedin.com/company/green-island-invest-hungary/",
    "https://www.youtube.com/@GreenIslandInvestZrt.",
  ],
};

export const HOSTING = {
  name: "Rackforest Zrt.",
  address: "1132 Budapest, Victor Hugo utca 11. 5. em. B05001",
  email: "ugyfelszolgalat@rackforest.hu",
  web: "https://rackforest.com",
};

export const formatAddress = (withLot = false) => {
  const { postalCode, city, street, lot } = COMPANY.address;
  return `${postalCode} ${city}, ${street}${withLot ? ` ${lot}` : ""}`;
};

export const telHref = (phone) => `tel:${phone.replace(/\s/g, "")}`;
